export const HTTP_STATUS_CODES = {
  OK: 200,
  MULTIPLE_CHOICE: 300,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  NO_RESPONSE: 444,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
} as const;

export const INTERCEPTION_HTTP_STATUSES = [
  HTTP_STATUS_CODES.BAD_REQUEST,
  HTTP_STATUS_CODES.UNAUTHORIZED,
  HTTP_STATUS_CODES.FORBIDDEN,
  HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,
  HTTP_STATUS_CODES.BAD_GATEWAY,
  HTTP_STATUS_CODES.SERVICE_UNAVAILABLE,
] as const;

export const typesOfElement = {
  button: 'button', // <button>
  link: 'link', // <NuxtLink>
} as const;

export const typeOfState = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  warn: 'warn',
  error: 'error',
  red: 'red',
  ghost: 'ghost',
} as const;

export const DROPDOWN_VISIBLE_ITEMS_NUMBER_DEFAULT = 4 as const;

export const SCREENS = {
  SM: 320,
  MD: 768,
  LG: 1024,
  XL: 1280,
} as const;

export const BOOKING_STATUSES = {
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
  IN_PROGRESS: 'IN_PROGRESS',
  PAST_BOOKING: 'PAST_BOOKING',
  incomplete: 'incomplete',
  complete: 'complete',
  draft: 'draft',
  new: 'new',
  EXTENDED: 'EXTENDED',
  submitted: 'submitted',
  edited: 'edited',
  ACTION_REQUIRED: 'ACTION_REQUIRED'
} as const;

export const HTTP_ERROR_TYPES = {
  BOOKING_ALREADY_CANCELLED: 'booking_already_cancelled',
} as const;

export const DOWNLOAD_ERROR_MESSAGES = {
  notfound: 'ticketsDownload.errorMessages.notfound',
  default: 'ticketsDownload.errorMessages.default',
} as const;

export const PHONE_DEFAULT_FORMAT = '______________' as const;
export const US_PHONE_DEFAULT_FORMAT = '(___) ___ - ____' as const;

export const THEMES = {
  PODS: 'PODS',
  PARKINGS: 'PARKINGS',
} as const;

export const AUTH0_COOKIE_PREFIXES = {
  WL: 'auth-wl.',
  PARTNERS: 'auth-ex.',
} as const;

export const PARTNER_TYPES = {
  providerAndWhitelabel: 1,
  providerOnly: 2,
  channel: 3,
  apiProvider: 4,
  whiteLabelOnly: 5,
  bookingPortal: 6,
} as const;

export const PARTNER_TYPES_CODES = {
  WL_ONLY: 'wl_only',
  PROVIDER_AND_WHITE_LABEL: 'provider_and_white_label',
  BOOKING_PORTAL: 'booking_portal'
} as const;

export const FORM_TYPES = {
  PODS: 'ESCAPE_PODS',
  PARKINGS: 'SIMPLE_PARKINGS',
  TRANSFERS: 'SHUTTLE_FINDER',
} as const;

export const STRIPE_LOCALIZATION = 'en' as const;

// These are the route names, not the paths
export const DEDICATED_AUTH0_FLOW = 'dedicated';
export const DEDICATED_WL_ROUTES = {
  INDEX: 'dedicated-wl-index',
  SEARCH: 'dedicated-wl-search',
  SELECT_EXTRAS: 'dedicated-wl-select-extras',
  SELECT_EXTRAS_PRODUCT: 'dedicated-wl-select-extras-product',
  CHECKOUT: 'dedicated-wl-checkout',
  RECEIPT: 'dedicated-wl-receipt',
} as const;

// These are the route paths
export const LOUNGE_PORTAL_ROUTES_PATH = {
  INDEX: '/lounge-portal',
  SEARCH: '/lounge-portal/search',
  SELECT_EXTRAS: '/lounge-portal/select-extras/',
  CHECKOUT: '/lounge-portal/checkout',
  RECEIPT: '/lounge-portal/receipt',
} as const;

// These are the route paths
export const DEDICATED_WL_ROUTES_PATH = {
  INDEX: '/dedicated',
  SEARCH: '/dedicated/search',
  SELECT_EXTRAS: '/dedicated/select-extras/',
  SELECT_EXTRAS_PRODUCT: '/dedicated/select-extras/product',
  MODIFY: '/dedicated/manage-booking/modify',
  CHECKOUT: '/dedicated/checkout',
  RECEIPT: '/dedicated/receipt',
} as const;

export const BOOKING_PORTAL_AUTH0_FLOW = 'booking-portal';
export const BOOKING_PORTAL_FLOW_ROUTES_PATH = {
  INDEX: '/booking-portal',
  SEARCH: '/booking-portal/search',
  SELECT_EXTRAS: '/booking-portal/select-extras',
  MODIFY: '/booking-portal/manage-booking/modify',
  CHECKOUT: '/booking-portal/checkout',
  MODIFY_CHECKOUT: '/booking-portal/modify-checkout',
} as const


/**
 * Route names that allow page progress indicators
 */
export const PROGRESS_INDICATOR_PAGES = {
  search: 'index',
  checkout: 'checkout',
  choose: 'search',
  quote: 'quote',
  extras: 'select-extras',
  travel_extras: 'travel-extras',
  extras_product: 'select-extras-product',
  payment: 'payment',
} as const;

/**
 * Route names that allow page progress indicators
 */
export const LOUNGE_PORTAL_PROGRESS_INDICATOR_PAGES = {
  search: 'lounge-portal',
  checkout: 'lounge-portal-checkout',
  choose: 'lounge-portal-search',
  extras: 'lounge-portal-select-extras',
  travel_extras: 'travel-extras',
  extras_product: 'select-extras-product',
  payment: 'lounge-portal-payment',
} as const;
/**
 * Route names that allow page progress indicators for booking portal
 */
export const BOOKING_PORTAL_PROGRESS_INDICATOR_PAGES = {
  search: 'booking-portal',
  checkout: 'booking-portal-checkout',
  choose: 'booking-portal-search',
  extras: 'booking-portal-select-extras',
  travel_extras: 'travel-extras',
  extras_product: 'select-extras-product',
  payment: 'booking-portal-payment',
} as const;

export const MY_BOOKINGS_REDIRECTION_PAGES = {
  search: 'index',
  choose: 'search',
  extras: 'select-extras',
} as const;

export const enum CookiesNames {
  manage = 'manageBookingToken',
}

export const SEARCH_BOX_SESSION_DURATION: Readonly<number> = 120; // minutes
export const SELECT_TERMINAL_ERROR_DURATION: Readonly<number> = 7000; // seconds
export const CART_REVALIDATION_INTERVAL: Readonly<number> = 900; // seconds, 15 minutes
export const PAYMENT_EMPTY_CART_ERROR_DURATION: Readonly<number> = 7000; // seconds
export const REQUEST_FREEZE_CHECK_TIME: Readonly<number> = 60000; // miliseconds, 1 minute
export const UPDATE_DETAILS_MESSAGE_TIME_ALIVE: Readonly<number> = 60000; // miliseconds, 1 minute
export const LOCAL_ERROR_SHOW_TIME: Readonly<number> = 7000; // 7 seconds

export const PODS_SEARCH_DEFAULT_TIME: Readonly<string> = '00:00';

export const MIDDAY: Readonly<string> = '12:00';

export const DEFAULT_MAP_ZOOM: Readonly<number> = 17;

export const SEARCH_RESULTS_LIFETIME: Readonly<number> = 15; // minutes
export const PODS_DEFAULT_BOOKING_DURATION: Readonly<number> = 15; // minutes

export const PAYMENT_FORM_DATA_LIFETIME: Readonly<number> = 120; // minutes

export const PODS_AVAILIBLE_BOOKING_SLOTS = [
  { duration: 15, price: 10 },
  { duration: 30, price: 15 },
  { duration: 45, price: 25 },
  { duration: 60, price: 30 },
  { duration: 90, price: 45 },
  { duration: 120, price: 60 },
] as const;

export const PAYMENT_FORM_DATA = {
  firstname: '',
  lastname: '',
  email: '',
  phone: {
    phoneNumber: '',
    formattedNumber: '',
    countryCode: '',
  },
} as const;

export const MAX_COUNT_CART: Readonly<number> = 5;

export const MODAL_ERROR_MESSAGES = {
  reload_page: `Please, try again and reload the page <br> If it still doesn’t work -<a href='${process.env['NUXT_ENV_CONTACT_PAGE_URL']}' class="text-highlighted">&nbsp;Contact Us</a>`,
  max_limit:
    'Sorry, this item can’t be added because you have the maximum number of 5 items in your cart.<br> Please remove an item from your cart and try again.',
  same_pod: 'Looks like you already added this Escape Pod to the cart',
  customer_service: `Please contact <a href='${process.env['NUXT_ENV_CONTACT_PAGE_URL']}' class="text-highlighted">customer service</a>`,
  booking_connection_lost:
    'Sorry, something went wrong. Looks like the network connection was lost.<br> You will receive the confirmation email if your booking was completed successfully',
} as const;

export const MODAL_ERROR_CODES = {
  featureFlagSearchValidationError: '#1',
  searchParkingProductsError: '#2',
  searchLoungeProductsError: '#3',
  submitLoungeProductsError: '#4',
  modifyLoungeProductsError: '#5',
  addLoungeToCartError: '#6',
  searchExtrasProductsError: '#7',
  searchFasttrackProductsError: '#8',
  searchFasttrackProductsWidgetError: '#9',
  getFlightsError: '#10',
  noDataError: '#11',
  internalServerError: '#12',
  notFoundError: '#13',
} as const;

export const COLORS = {
  PODS_BRAND: '#38A4A2',
  MAG_ELEMENTS_ICONS_ON_DARK: '#64687E',
} as const;

export const PRODUCT_CODES = {
  pods: 'pods',
} as const;

export const STRIPE_JS: Readonly<string> = 'https://js.stripe.com/v3';

export const UNSUPPORTED_BROWSERS = ['Internet Explorer'] as const;

export const CANT_FIND_FLIGHT_ID = null;

export const STRIPE_ERROR_CODES = {
  incomplete_number: 'incomplete_number',
  incomplete_expiry: 'incomplete_expiry',
  incomplete_cvc: 'incomplete_cvc',
} as const;

export const LOUNGE_PORTAL_CARDHOLDER_ACCESS_TYPES = {
  DinersClub: 1,
  DragonPass: 2,
  DreamFolks: 3,
  LoungeKey: 4,
  LoungePass: 5,
  PriorityPass: 6,
  TAVPassport: 7,
  AMEXCenturion: 8,
  AMEXPlatinum: 9,
  DeltaReserve: 10,
  LoungeBuddy: 11,
  PlazaPremium: 12,
}

export const LOUNGE_PORTAL_DEFAULT_EMAIL = 'booking@ca.vu';

export const NAMED_ROUTES = {
  home: '/',
  dedicated_home: '/dedicated',
  maintenance: '/maintenance',
  cart: '/cart',
  select_extras: {
    default: '/select-extras',
    dedicated_default: '/dedicated/select-extras',
    product: '/select-extras/product',
    dedicated_product: '/dedicated/select-extras/product',
  },
  travel_extras: '/travel-extras',
  dedicated_travel_extras: '/dedicated/travel-extras',
  payment: '/payment',
  receipt: '/receipt',
  search: '/search',
  quote: '/quote',
  select_terminal: '/select-terminal',
  unsupported_browser: '/unsupported-browser',
  manage_booking: {
    default: '/manage-booking',
    search: '/search-booking',
    update_details: '/manage-booking/update-details',
    cancel: '/manage-booking/cancel',
    cancel_receipt: '/manage-booking/cancel/receipt',
  },
  downloads: {
    ticket: '/downloads/ticket/',
    error: '/downloads/error/',
  },
  booking_products: {
    home: '/booking-products',
  },
  booking_guest_details: {
    home: '/guests-details',
    questionnaire: '/guests-details/questionnaire',
  },
  booking_baggage_details: {
    home: '/baggage-details',
  },
  my_profile: '/my-profile',
  not_found: '/404',
} as const;

export const ROUTE_NAMES = {
  booking_app: {
    home: 'booking-home',
    search: 'booking-search',
    select_extras: 'booking-select-extras',
  },
  home: 'index',
  maintenance: 'maintenance',
  cart: 'cart',
  select_extras: 'select-extras',
  travel_extras: 'travel-extras',
  lounge_portal: 'lounge-portal',
  payment: 'payment',
  receipt: 'receipt',
  search: 'search',
  dedicated_search: 'dedicated-wl-search',
  select_terminal: 'select-terminal',
  unsupported_browser: 'unsupported-browser',
  manage_booking: {
    default: 'manage-booking',
    search: 'search-booking',
    update_details: 'manage-booking-update-details',
    cancel: 'manage-booking-cancel',
    cancel_receipt: 'manage-booking-cancel-receipt',
  },
  my_profile: 'my-profile',
  not_found: '404',
} as const;

export const PARKINGS_TIMEPICKER_STEPS: Readonly<number> = 60; // minutes
export const LOUNGES_TIMEPICKER_STEPS: Readonly<number> = 15; // minutes
export const LOUNGES_CATEGORY_TYPES = {
  ALL: 'all',
  CHECKED_BAGGAGE: 'checked_baggage',
  CABIN_BAGGAGE: 'cabin_baggage',
} as const;

export const GUEST_GROUPS = {
  SENIOR: 'senior',
  ADULT: 'adult',
  CHILD: 'child',
  INFANT: 'infant',
}

export const PAYPAL_MAXIMUM_DAYS_FORM_PAYMENT: Readonly<number> = 180; // Days

export const SECURITY_TOKEN_EXPIRATION: Readonly<number> = 1800; // 30 minutes
export const SECURITY_CHECK_INTERVAL: Readonly<number> = 30000; // 30 seconds

export const BARRIER_ACCESS_TYPES = {
  QRCODE: 'QrCode',
  BARCODE: 'BarCode',
  PINCODE: 'Pin',
  ANPR: 'anpr',
  NONE: 'none',
} as const;

export const FALLBACK_LOCALE = 'en-US' as const;

export const PARKING_CATEGORY_TYPES = {
  ALL: 'all',
  ON_AIRPORT: 'category_type_on_airport',
  OFFSITE_PARK_AND_RIDE: 'category_type_offsite',
  MEET_AND_GREET_NO_TRANSFER: 'category_type_no_transfer',
} as const;

export const PARKING_SORT_OPTIONS = {
  RECOMMENDED: 'recommended',
  PRICE: 'price',
  DISTANCE: 'distance',
} as const;

export const EXTRAS_PRODUCT_CODES = {
  ALL: 'all',
  LOUNGES: 'lounges',
  FASTTRACK: 'fasttrack',
  TRAVEL_INSURANCE: 'travel_insurance',
  EXTRAS: 'extras',
  PARKING: 'parking',
} as const;

export const enum MANAGE_BOOKING_KEYS {
  search = 'search',
  resend = 'resend',
}

export const defaultActiveTab: Readonly<MANAGE_BOOKING_KEYS.search> =
  MANAGE_BOOKING_KEYS.search;

export const tabs = [
  {
    key: MANAGE_BOOKING_KEYS.search,
    text: 'Search for booking',
  },
  {
    key: MANAGE_BOOKING_KEYS.resend,
    text: 'Resend confirmation',
  },
] as const;

/**
 * Used to work out what profile setting to show
 * @enum
 */
export const enum PROFILE_SETTINGS_COMPONENTS {
  name = 'FullName',
  phone = 'Phone',
  vehicle = 'Vehicle',
  password = 'Password',
  postcode = 'PostalCode',
  mp = 'MarketingPreferences',
}

export const enum GA_IDs {
  FIND_BOOKING = 'GAFindBooking',
  NOT_FOUND = 'GABookingNotFound',
}

export const PAYMENT_PROVIDERS = {
  BRAINTREE: 'braintree',
  STRIPE: 'stripe',
  WINDCAVE: 'windcave',
  ADVAM: 'advam',
} as const;

type PaymentProviders = typeof PAYMENT_PROVIDERS;
export type PaymentProvider = PaymentProviders[keyof PaymentProviders] | null;

export const PAYMENT_PROVIDERS_IDS = {
  'development': {
    1: 'STRIPE',
    2: 'BRAINTREE',
    3: 'WINDCAVE',
    4: 'ADVAM',
  },
  'test': {
    1: 'STRIPE',
    2: 'BRAINTREE',
    6: 'WINDCAVE',
    7: 'ADVAM',
  },
  'uat': {
    1: 'STRIPE',
    2: 'BRAINTREE',
    3: 'WINDCAVE',
    4: 'ADVAM',
  },
  'live': {
    1: 'STRIPE',
    2: 'BRAINTREE',
    3: 'WINDCAVE',
    4: 'ADVAM',
  },
} as const;

type StripeConfig = {
  statement_descriptor: string;
};

type WindcaveConfig = {
  payment_apple_merchant_id: string,
  payment_google_business_id: string,
  payment_google_merchant_id: string,
};

type BraintreeConfig = {
  merchant_account_id: string,
  merchant_id: string,
  private_key: string,
  public_key: string,
};

export type PaymentConfig = {
  id: number;
  is_active: boolean;
  payment_provider_id: 1 | 2 | 3;
  merchant_id: string;
  config: StripeConfig | WindcaveConfig | BraintreeConfig;
};

type DevPaymentProviderIds = typeof PAYMENT_PROVIDERS_IDS.development;
type TestPaymentProviderIds = typeof PAYMENT_PROVIDERS_IDS.test;
type UATPaymentProviderIds = typeof PAYMENT_PROVIDERS_IDS.uat;
type LivePaymentProviderIds = typeof PAYMENT_PROVIDERS_IDS.live;
type PaymentProviderIds = DevPaymentProviderIds | TestPaymentProviderIds | UATPaymentProviderIds | LivePaymentProviderIds;
export type PaymentProviderId = keyof PaymentProviderIds;

export const PAYMENT_METHOD_STRATEGIES = {
  NEW_PAYMENT_ONLY: 'NewPaymentOnly',
  SAVE_CARD_PAYMENT_METHOD: 'SaveCardPaymentMethod',
} as const;

export const PAYMENT_PROVIDER_COLORS = {
  MAG_ELEMENTS_ICONS_ON_DARK: '#64687E',
  STRIPE: {
    PRIMARY: '#ff0000',
    BACKGROUND: '#ffffff',
    TEXT: '#7B8297',
    DANGER: '#df1b41',
  },
} as const;

export const PAYMENT_METHODS = {
  BRAINTREE: {
    HOSTED_FIELDS: 'braintree-hosted-fields',
    PAYPAL: 'braintree-paypal',
  },
  STRIPE: {
    HOSTED_FIELDS: 'stripe-hosted-fields',
  },
  WINDCAVE: {
    HOSTED_FIELDS: 'windcave-hosted-fields',
  },
} as const;

export const enum PaymentMethods {
  StripeHostedFields = 'stripe-hosted-fields',
  BraintreeHostedFields = 'braintree-hosted-fields',
  BraintreePaypal = 'braintree-paypal',
}
export const TEXT_INPUT_DEBOUNCE_TIME = 250;

export const ContinueBookingStatuses = {
  Successful: 'successful',
  Failed: 'failed',
};

export const COLOUR_SCHEMES = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const APP_HERO_PRODUCTS = {
  LOUNGES: 'lounges',
  PARKING: 'parking',
  FASTTRACK: 'fasttrack',
  TRAVEL_INSURANCE: 'travel_insurance',
  HOTELS: "hotels",
  TRANSERS: "transfers",
  PODS: "pods",
  RETAILS: "retails",
  EXTRAS: "extras"
} as const;

export const APP_HERO_PRODUCT_NAMES = {
  LOUNGES: 'Lounges',
  PARKING: 'Parking',
  FASTTRACK: 'Fast track',
  TRAVEL_INSURANCE: 'Travel Insurance',
  HOTELS: "Hotels",
  TRANSERS: "Transfers",
  PODS: "Pods",
  RETAILS: "Retails",
  EXTRAS: "Extras"
} as const;

type HeroProducts = typeof APP_HERO_PRODUCTS;
export type HeroProduct = HeroProducts[keyof HeroProducts];

export const PRODUCT_TYPES = {
  ...APP_HERO_PRODUCTS,
  EXTRAS: 'extras',
  LOUNGE_PRIVATE: 'lounge_private'
} as const;

export const PRODUCT_TYPE_NAMES = {
  ...APP_HERO_PRODUCT_NAMES,
  EXTRAS: '+ Extras',
} as const;

type AppProductTypes = typeof PRODUCT_TYPES;
export type ProductType = AppProductTypes[keyof AppProductTypes];

export const APP_LABELS = {
  ACCOUNT: 'account',
  CHECKOUT: 'checkout',
  ECOMMERCE: 'ecommerce',
} as const;

export const BAGGAGE_SELECTOR_OPTIONS = {
  checked_baggage: 'checked_baggage',
  cabin_baggage: 'cabin_baggage',
  none: 'none',
} as const;

export const VEHICLE_OCCUPANTS = [
  {
    id: 0,
    name: '0',
  },
  {
    id: 1,
    name: '1',
  },
  {
    id: 2,
    name: '2',
  },
  {
    id: 3,
    name: '3',
  },
  {
    id: 4,
    name: '4',
  },
  {
    id: 5,
    name: '5',
  },
  {
    id: 6,
    name: '6',
  },
  {
    id: 7,
    name: '7',
  },
  {
    id: 8,
    name: '8',
  },
] as const;

/**
 * Denotes the step at which a user added an item to the cart.
 */
export const ATTACHMENT_TYPE = {
  PRIMARY: 'primary',
  PRIMARY_BUNDLE: 'primary_bundle',
  CROSS_SELL: 'cross_sell',
  MODIFY: 'modify',
} as const;
export type AttachmentType = typeof ATTACHMENT_TYPE[keyof typeof ATTACHMENT_TYPE];

export const FEATURE_FLAGS = {
  A11Y_70_ACCESSIBILITY_STATEMENT_LINK_IN_FOOTER: 'A11Y-70-ACCESSIBILITY-STATEMENT-LINK-IN-FOOTER',
  AP_1478_SHARED_PAYMENT_WIDGET_MULTI_REGION: 'AP_1478_SHARED_PAYMENT_WIDGET_MULTI_REGION',
  AP_1480_MOVE_CHECKOUT_PAGES_INTO_THE_ECOMMERCE_APP: 'AP_1480_MOVE_CHECKOUT_PAGES_INTO_THE_ECOMMERCE_APP',
  GTD_3236_ADDING_CURRENCIES_TO_PROPEL_UI: 'GTD_3236_ADDING_CURRENCIES_TO_PROPEL_UI',
  GTD_3437_ADD_BOOKING_PORTAL_FLOW_PREFIX_PAH: 'GTD_3437_ADD_BOOKING_PORTAL_FLOW_PREFIX_PAH',
  PREM_636_AETHER_NEW_SEARCH_FORM: 'PREM-636-Aether-New-Search-Form',
  PREM_636_AETHER_PHASE_1_IMPROVEMENTS: 'PREM-636-Aether-Phase-1-Improvements',
  PREM_764_AETHER_OVERRIDE_DATE_LIMITATIONS: 'PREM-764-Aether-Override-Date-Limitations',
  PREM_797_AETHER_PAYMENT_SUMMARY_ADD_GUEST_DETAILS: 'PREM-797-Aether-Payment-Summary-Add-Guest-Details',
  PREM_856_AETHER_HIDE_BOOKING_BUTTONS: 'PREM-856-Aether-Hide-Booking-Buttons',
  AP_682_ENABLE_CUSTOM_CSS: 'AP_682_ENABLE_CUSTOM_CSS',
  IMP_1275_WINDCAVE_ENABLE_APPLE_PAY: 'IMP-1275_Windcave_Enable_Apple_Pay',
  IMP_1275_WINDCAVE_ENABLE_GOOGLE_PAY: 'IMP-1275_Windcave_Enable_Google_Pay',
  IMP_1300_WINDCAVE_ENABLE_MOBILE_MENU: 'IMP-1300_Windcave_Enable_Mobile_Menu',
  ECOM_3200_BOOK_BY_MAP: 'ECOM_3200_BOOK_BY_MAP',
  ECOM_3227_CHANGE_SAVING_TO_WAS: 'ECOM_3227_CHANGE_SAVING_TO_WAS',
  ECOM_3299_GTM_CONTAINER_TESTING: 'ecom-3299-gtm-container-testing',
  ECOM_3307_SHOW_BOOKING_FEE_AS_LINE_ITEM: 'ECOM_3307_SHOW_BOOKING_FEE_AS_LINE_ITEM',
  ECOM_3346_SHOW_CAVU_COMMISSION_SEPARATELY_FROM_CAVU_TAX: 'ECOM_3346_SHOW_CAVU_COMMISSION_SEPARATELY_FROM_CAVU_TAX',
  ECOM_3394_ORDER_CREATED_TAX_INVOICE: 'ECOM-3394-Order-Created-Tax-Invoice',
  EM_1149_ENABLE_UNIFIED_EXTRAS_FLOW: 'EM_1149_ENABLE_UNIFIED_EXTRAS_FLOW',
  WL_FEATURE_CONTROL_PER_PARTNER_ENABLE_MY_ACCOUNT: 'WL-FeatureControlPerPartnerEnableMyAccount',
  WL_GLOBAL_MAINTENANCE_MODE: 'WL-GlobalMaintenanceMode',
  WL_PRODUCT_CARD_REVIEW_STARS: 'WL-ProductCardReviewStars',
  PT_1566_DISPLAY_NEW_PAYMENT_SUMMARIES: 'PT-1566-DISPLAY-NEW-PAYMENT-SUMMARIES',
  PT_1595_SEARCH_VALIDATION: 'PT-1595-SEARCH-VALIDATION',
  PT_2857_FLIGHT_LOOKUP_PARKING: 'PT_2857_FLIGHT_LOOKUP_PARKING',
  PT_2857_FLIGHT_LOOKUP: 'PT_2857_FLIGHT_LOOKUP',
  PT_2971_VEHICLE_LOOKUP_IMPROVED_UI: 'PT_2971_VEHICLE_LOOKUP_IMPROVED_UI',
  PT_2973_PARKING_BOOKING_EXTENSION: 'PT_2973_PARKING_BOOKING_EXTENSION',
  GTM_322_DEPOSIT_ONLY_PRODUCTS: 'gtm-322-deposit-only-products',
  CRO_828_MULTILINE_SEARCH_BOX: 'CRO_828_MULTILINE_SEARCH_BOX',
  CRO_857_LOADING_SCREEN_STEPS: 'CRO_857_LOADING_SCREEN_STEPS',
  CRO_887_BACK_MODALS_FUNCTIONALITY: 'CRO_887_BACK-MODALS-FUNCTIONALITY',
  CRO_922_SEARCH_PRODUCT_CARD_TRAVEL_EXTRA_GALLERY: 'CRO_922_SEARCH_PRODUCT_CARD_TRAVEL_EXTRA_GALLERY',
  CRO_923_NEW_LOUNGE_PRODUCT_CARDS: 'CRO_923_NEW_LOUNGE_PRODUCT_CARDS',
  CRO_933_STICKY_BOTTOM_CTA_ON_TRAVEL_EXTRAS_PAGE: 'CRO_933_STICKY_BOTTOM_CTA_ON_TRAVEL_EXTRAS_PAGE',
  CRO_939_BUNDLE_MORE_INFO: 'CRO_939_BUNDLE_MORE_INFO',
  CRO_970_NEW_FASTTRACK_PRODUCT_CARDS: 'CRO_970_NEW_FASTTRACK_PRODUCT_CARDS',
  CRO_1009_HIDE_TERMINAL_DONT_KNOW_OPTION: 'CRO_1009_HIDE_TERMINAL_DONT_KNOW_OPTION',
  CRO_1027_DISCOUNT_CODE_PAYMENT_SECTION: 'CRO_1027_DISCOUNT_CODE_PAYMENT_SECTION',
  CRO_1149_REMOVE_ACCREDITATIONS: 'CRO_1149_REMOVE_ACCREDITATIONS',
  NGQ_11_TIMESLOT: 'NGQ_11_TimeSlot',
  NGQ_344_SMART_WALLET: 'NGQ-344-smart-wallet',
  CUS_2394_CASHBACK_PROVIDER: 'CUS_2394_CASHBACK_PROVIDER',
  CUS_2533_DEDICATED_BOOKING_FLOW: 'CUS_2533_DEDICATED_BOOKING_FLOW',
  FEAT_CUS_3290_ENABLE_COOKIE_ENCODING: 'FEAT_CUS_3290_ENABLE_COOKIE_ENCODING',
  EM_228_TRAVEL_INSURANCE: 'EM-228-TRAVEL-INSURANCE',
  EM_1120_TRAVEL_INSURANCE_BATTLEFACE_UPSELL: 'EM_1120_TRAVEL_INSURANCE_BATTLEFACE_UPSELL',
  ECOM_3797_VEHICLE_ROADWORTHY_AND_WEIGHT: 'ECOM-3797_VEHICLE_ROADWORTHY_AND_WEIGHT',
  ECOM_3834_LINK_TO_LIST_OF_NOT_ALLOWED_VEHICLES: 'ECOM-3834_LINK_TO_LIST_OF_NOT_ALLOWED_VEHICLES',
  CRO_844_FEEFO_REVIEW_WITHIN_FLOW: 'CRO_844_FEEFO_REVIEW_WITHIN_FLOW',
  CRO_534_SECURE_PAYMENT_MESSAGE_ON_TOP: 'CRO_534_SECURE_PAYMENT_MESSAGE_ON_TOP',
  ECOM_3837_VEHICLE_ROADWORTHY_AND_WEIGHT_VALIDATION: 'ECOM_3837_VEHICLE_ROADWORTHY_AND_WEIGHT_VALIDATION',
  CRO_1123_NEW_PRICE_STYLING: 'CRO_1123_NEW_PRICE_STYLING',
  CRO_1131_MOBILE_PRODUCT_CARD_NEW_UI: 'CRO_1131_MOBILE_PRODUCT_CARD_NEW_UI',
  EM_1188_WAIT_FOR_PUSHER_CONNECTION: 'EM_1188_WAIT_FOR_PUSHER_CONNECTION',
  EM_1182_REMOVE_PUSHER: 'EM_1182_REMOVE_PUSHER',
  MC_106_CREATE_ORDER_CHANNEL_SELECTOR_EXTRANETS: 'MC_106_CREATE_ORDER_CHANNEL_SELECTOR_EXTRANETS',
  EX_486_AETHER_PARKING_TRAVEL_EXTRA: 'EX_486_AETHER_PARKING_TRAVEL_EXTRA',
  CRO_1117_CANCEL_FOR_FREE_CALLOUT: 'CRO_1117_CANCEL_FOR_FREE_CALLOUT',
  CRO_1077_PROGRESS_INDICATOR_STEP_RENAMING: 'CRO_1077_PROGRESS_INDICATOR_STEP_RENAMING',
  CRO_1138_MOBILE_CARD_DESIGN_V2_NEW: 'CRO_1138_MOBILE_CARD_DESIGN_V2_NEW',
  CRO_1156_TERMINAL_NAME_CHANGE: 'CRO_1156_TERMINAL_NAME_CHANGE',
  CRO_1064_SHOW_COUNTDOWN_ON_CHECKOUT: 'CRO_1064_SHOW_COUNTDOWN_ON_CHECKOUT',
  CRO_1175_TERMINAL_NAME_CHANGE: 'CRO_1175_TERMINAL_NAME_CHANGE',
  CRO_1185_COMING_SOON: 'CRO_1185_COMING_SOON',
  MC_63_PARTNER_GROUP_SETUP: 'MC_63_PARTNER_GROUP_SETUP',
  ECOM_3848_ADD_GTM_URL: 'ECOM_3848_ADD_GTM_URL',
  EX_239_PURCHASE_SINGLE_EXTRAS: 'EX_239_PURCHASE_SINGLE_EXTRAS',
};

export const FS_FEATURE_FLAGS = [
  FEATURE_FLAGS.CRO_534_SECURE_PAYMENT_MESSAGE_ON_TOP,
  FEATURE_FLAGS.CRO_844_FEEFO_REVIEW_WITHIN_FLOW,
  FEATURE_FLAGS.ECOM_3200_BOOK_BY_MAP,
  FEATURE_FLAGS.CRO_939_BUNDLE_MORE_INFO,
  FEATURE_FLAGS.CRO_1027_DISCOUNT_CODE_PAYMENT_SECTION,
  FEATURE_FLAGS.CRO_1123_NEW_PRICE_STYLING,
  FEATURE_FLAGS.CRO_1117_CANCEL_FOR_FREE_CALLOUT,
  FEATURE_FLAGS.CRO_1131_MOBILE_PRODUCT_CARD_NEW_UI,
  FEATURE_FLAGS.CRO_1149_REMOVE_ACCREDITATIONS,
  FEATURE_FLAGS.CRO_1064_SHOW_COUNTDOWN_ON_CHECKOUT,
];
